export const pixelId = "939623849833574";
export const accessToken =
  "EAAZAUmxlcVcYBPHa4OlbBiKu0edoWKZBnER8pNZAVSaw2mfuppZA0zdOw1HiUSTjwzNv38ew1E5jEuMvA50XB6ts40F9bsIdV0LR7Ittq5MVOKLCY13wIBoVqZCUF1VBx4UTJNZB9m1n6YdYyncCUKHeIGYCyClGBEhIQebgNszHwp4AYBuAmjF7pj3agpSAZDZD";

export const fbApiUrl = `https://graph.facebook.com/v18.0/${pixelId}/events?access_token=${accessToken}`;
